// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__r2p_g"};